import { createTheme } from '@mui/material/styles';
import { variables } from './variables';
import { style } from './style';

export const theme = createTheme({
  palette: {
    common: {
      black: style.black,
      white: style.white,
    },
    primary: {
      main: style.brandPrimary,
    },
    secondary: {
      main: style.grayLighter,
    },
    error: {
      main: style.brandDanger,
    },
    text: {
      primary: style.grayDark,
      secondary: style.grayDarker,
    },
  },
  typography: {
    htmlFontSize: 13,
    fontSize: 13,
    fontFamily: variables.fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontFamily: variables.fontFamily,
      fontSize: '3rem',
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: variables.fontFamily,
      fontSize: '2.4rem',
      lineHeight: 1.1,
    },
    h3: {
      fontFamily: variables.fontFamily,
      fontSize: '2.2rem',
      lineHeight: 1.1,
    },
    h4: {
      fontFamily: variables.fontFamily,
      fontSize: '2rem',
      lineHeight: 1.1,
    },
    h5: {
      fontFamily: variables.fontFamily,
      fontSize: '1.8rem',
      lineHeight: 1.1,
    },
    h6: {
      fontFamily: variables.fontFamily,
      fontSize: '1.6rem',
      lineHeight: 1.1,
    },
    body1: {
      fontFamily: variables.fontFamily,
      fontWeight: 400,
      fontSize: '1.3rem',
    },
    caption: {
      fontFamily: variables.fontFamily,
      fontWeight: 500,
      fontSize: '1.2rem',
      color: variables.grayLight,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          // color: variables.gray,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          border: '1px solid transparent',
          paddingLeft: '32px',
          paddingRight: '32px',
        },
        colorPrimary: {
          backgroundColor: variables.brandCBP,
          borderColor: variables.borderCBP,
        },
        colorSecondary: {
          backgroundColor: variables.grayLighter,
          borderColor: variables.borderAppHeader,
        },
      },
    },
    // MuiTabs: {
    //   styleOverrides: {
    //     indicator: {
    //       backgroundColor: 'transparent',
    //     },
    //   },
    // },
    MuiToolbar: {
      styleOverrides: {
        dense: {
          minHeight: 50,
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: '1.3rem' },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          // backgroundColor: variables.grayLightest,
          boxShadow: 'none',
          border: variables.cardBorder,
          borderRadius: '5px',
          padding: '1.5rem',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
          '&:last-child': {
            paddingBottom: 0,
          },
        },
      },
    },
    MuiCollapse: {
      styleOverrides: {
        wrapper: {},
        wrapperInner: {
          margin: '0 0',
          display: 'flex',
          justifyContent: 'space-between',
          flexFlow: 'wrap',
        },
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderBottom: variables.basicBorder,
        },
      },
    },

    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          borderBottom: variables.basicBorder,
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '13px',
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          '& input': {
            padding: '0.5216153em', // input height 29px
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '0.46899883999em',
        },
      },
    },

    MuiTable: {
      styleOverrides: {
        root: {
          '& caption': {
            captionSide: 'top',
            fontSize: '1.5rem',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&$selected': {
            backgroundColor: '#EDF3F9',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontSize: '13px',
        },
        body: {
          fontSize: '13px',
        },
        stickyHeader: {
          backgroundColor: variables.grayLightest,
          borderBottom: variables.basicBorder,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          color: variables.gray,
          backgroundColor: variables.grayLighter,
          borderBottom: variables.basicBorder,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: 5,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          paddingBottom: '5px',
        },
        underlineAlways: {
          color: variables.brandInfo,
          textDecoration: 'none',
          borderBottomWidth: '1.5px',
          borderBottomColor: 'inherit',
          borderBottomStyle: 'solid',
        },
        underlineHover: {
          textDecoration: 'none',
          '&:hover': {
            color: variables.brandInfo,
            textDecoration: 'none',
            borderBottomWidth: '1.5px',
            borderBottomColor: 'inherit',
            borderBottomStyle: 'solid',
          },
        },
        underlineNone: {
          textDecoration: 'none',
          border: 'none',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderBottom: variables.tabBorder,
          maxWidth: 'unset',
          '&:nth-child(even)': {
            marginLeft: '-1px',
            marginRight: '-1px',
          },
          '&:last-child': {
            marginLeft: '-1px',
            marginRight: '0',
          },
          wrapper: {
            alignItems: 'baseline',
          },
        },
        textColorPrimary: {
          styleOverrides: {
            color: variables.grayDark,
            '&$selected': {
              color: 'inherit',
              borderTop: variables.tabBorder,
              borderRight: variables.tabBorder,
              borderLeft: variables.tabBorder,
              borderBottom: 'none',
              borderRadius: '3px',
            },
          },
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          padding: 12,
          borderLeftWidth: 4,
          border: '1px solid #ddd',
          borderRadius: 2,
          boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
          color: 'inherit',
          fontSize: 'inherit',
        },
        message: {
          padding: 0,
        },
      },
    },
  },
});
